import { CarryoverAddressValidationOutcome } from '../../enums/carryover-address-validation-outcome.enum';
import { TravelSchedulerTask } from '../../interfaces/travel-scheduler/travel-scheduler-task';

export class CarryoverValidationUtils {
  /**
   * Whether the task's carryover parking is validated. A task which loaded with an
   * address already saved against it passes untouched, so opening a schedule to edit never blocks; changing
   * the address means the new one has to be validated.
   */
  public static isCarryoverValidated(task: TravelSchedulerTask): boolean {
    if (!task?.isSupplierCarryingover) {
      return true;
    }

    if (!task.carryoverAddress) {
      return false;
    }

    if (!task.carryoverAddressChanged) {
      return true;
    }

    // A check we could not make is not the supplier's fault, so it does not block them. The carryover is
    // re-evaluated server side when the schedule is saved.
    return (
      task.carryoverValidation?.outcome === CarryoverAddressValidationOutcome.Suitable ||
      task.carryoverValidation?.outcome === CarryoverAddressValidationOutcome.CheckUnavailable
    );
  }
}
